module.exports = __webpack_public_path__ + "img/chr_ts_19_penlight.59146227.png";